module.exports = __webpack_public_path__ + "static/media/energia-card.af4085b0.png";